import { ThemeProvider } from '@vimeo/bokeh';

import { type AccentColor } from './type';
import { useAccentTheme } from './useAccentTheme';

export type AccentThemeProviderProps = React.PropsWithChildren<{
  accentColor?: AccentColor;
}>;

export function AccentThemeProvider({ accentColor, ...rest }: AccentThemeProviderProps) {
  const accentProps = useAccentTheme(accentColor);

  return <ThemeProvider {...accentProps} {...rest} />;
}
